<div class="zonaTrabajo">
  <div class="encabezado">
    <div class="botonesModales" style="margin-top: 2vh; margin-bottom: 2vh; margin-left: 2vw;">
      <div class="w3-row colorBotonDeNuevo" style="margin-left: 5vh; gap: 5px;" (click)="clickEncabezado('funcionalidades')">
        <span>{{'acciones.create-plan' | translate}}</span>
        <mat-icon class="iconoMen">add_circle_outline</mat-icon>
      </div>
      <mat-icon class="iconoMen" [matMenuTriggerFor]="menuTable">more_vert</mat-icon>
      <mat-menu #menuTable="matMenu">
        <button mat-menu-item (click)="excelExport()">
          {{ 'acciones.exportarExcel' | translate}}
          <mat-icon>description</mat-icon>
        </button>
      </mat-menu>
      </div>
  </div>
  <div class="tabla">
    <table class="tabla-aleema">
      <thead>
        <tr>
          @for (h of headers; track $index) {
            @switch (h.key) {
              @case ('progreso') {
                <th class="th-gantt">
                  <div class="gantt-ruler">
                    @for (mes of meses; track $index) {
                      <div class="gantt-mes-label" [style.width]="getMesWidth(mes)">{{mes.name}}</div>
                    }
                  </div>
                </th>
              }
              @case ('adicionales') {
                @for (ad of adicionales; track $index) {
                  <th>
                    <span>{{ad.nombre}}</span>
                  </th>
                }
              }
              @default {
                <th>
                  <div class="encabezado-columna">
                    <span>{{h.label}}</span>
                    @if(h.icono){
                      <mat-icon class="iconoMen colorBotonDeNuevo"
                        (click)="clickEncabezado(h.key)"
                        [matTooltip]="h.tooltip"
                      >add_circle_outline</mat-icon>
                    }
                    @if(h.sortable){
                      <div (click)="cambioFiltro(h.key)">
                        @switch (iconoFiltro(h.key)) {
                          @case ('id') {<mat-icon class="iconoSortIni">sort_by_alpha</mat-icon>} 
                          @case ('asc') {<mat-icon class="iconoSortIni">vertical_align_bottom</mat-icon>} 
                          @case ('des') {<mat-icon class="iconoSortIni">vertical_align_top</mat-icon>} 
                          @case ('nous') {<mat-icon class="iconoSortIni">filter_list_off</mat-icon>} 
                        }
                      </div>
                    }
                  </div>
                </th>
              }
            }
          }
          <!-- Columna del Gantt -->
        </tr>
      </thead>
      <tbody>
        @for (elem1 of data; track $index) {
          @if (vizualizarProyecto(elem1.fin, elem1.inicio)) {
            <tr>
              @for (h of headers; track $index) {
                @switch (h.key){
                  @case ('funcionalidades') {
                    <td>
                      <mat-icon class="w3-button iconoMen" (click)="elem1.expandido = !elem1.expandido"
                      [matTooltip]="elem1.expandido?'Contraer':'Expandir'">
                        {{elem1.expandido ? 'expand_less':'expand_more'}}
                      </mat-icon>
                      <mat-icon class="iconoMen colorBotonDeNuevo"
                          matTooltip="agregar" (click)="clickTabla('add', 'actividad')"
                        >add_circle_outline</mat-icon>
                      <mat-icon class="w3-button iconoMen" (click)="clickTabla('edit', 'proyecto', elem1)">edit</mat-icon>
                      <mat-icon class="iconoMen w3-button" (click)="clickTabla('delete', 'proyecto', elem1)">delete</mat-icon>
                    </td>
                  }
                  @case ('adicionales') {
                    @for (ad of adicionales; track $index) {
                    <td>
                      {{elem1[h.key]}}
                    </td>
                  }
                  }
                  @case ('progreso') {
                    <td class="borderAllLow td-gantt">
                      <div class="gantt-track">
                        <div class="gantt-grid-lines"></div>
                        <div class="gantt-bar gantt-bar-plan"
                          [style.left]="getBarLeft(elem1.inicio)"
                          [style.width]="getBarWidth(elem1.inicio, elem1.fin)">
                        </div>
                      </div>
                    </td>
                  }
                  @default {
                    <td [matTooltip]="elem1[h.key]" [appOverflowTooltip]="elem1[h.key]"
                    [ngClass]="{'centrar': h.key === 'inicio' || h.key === 'fin'}">
                      @if(h.key !== 'inicio' && h.key !== 'fin'){
                        {{elem1[h.key]}}
                      }@else {
                        {{escrituraDate(elem1[h.key])}}
                      }
                    </td>
                  }
                }
              }
            </tr>
            @if (elem1.expandido) {
              @for (elem2 of elem1.series; track $index) {
                @if(vizualizarActividad(elem2.fin, elem2.inicio)){
                  <tr>
                    @for (h of headers; track $index) {
                      @switch (h.key){
                        @case ('funcionalidades') {
                          <td>
                            <mat-icon class="w3-button iconoMen"></mat-icon>
                            <mat-icon class="w3-button iconoMen"></mat-icon>
                            <mat-icon class="w3-button iconoMen" (click)="clickTabla('edit', 'actividad', elem2)">edit</mat-icon>
                            <mat-icon class="iconoMen w3-button" (click)="clickTabla('delete', 'actividad', elem2)">delete</mat-icon>
                          </td>
                        }
                        @case ('adicionales') {
                          @for (ad of adicionales; track $index) {
                          <td>
                            {{elem2[h.key]}}
                          </td>
                        }
                        }
                        @case ('progreso') {
                          <td class="borderAllLow td-gantt">
                            <div class="gantt-track">
                              <div class="gantt-grid-lines"></div>
                              <div class="gantt-bar gantt-bar-act"
                                [style.left]="getBarLeft(elem2.inicio)"
                                [style.width]="getBarWidth(elem2.inicio, elem2.fin)">
                              </div>
                            </div>
                          </td>
                        }
                        @default {
                          <td [matTooltip]="elem2[h.key]" [appOverflowTooltip]="elem2[h.key]"
                          [ngClass]="{'centrar': h.key === 'inicio' || h.key === 'fin'}">
                            @if(h.key !== 'inicio' && h.key !== 'fin'){
                              {{elem2[h.key]}}
                            }@else {
                              {{escrituraDate(elem2[h.key])}}
                            }
                          </td>
                        }
                      }
                    }
                  </tr>
                }
              }
            }
          }
        }
      </tbody>
    </table>
  </div>
</div>